type WithGradientProps = {
  className: string
}
export default function WithGradient({ className }: WithGradientProps): JSX.Element {
  return <div className={`bg-gradient-to-r from-green-dark-landing to-green-light-landing ${className ?? ''}}`} />
}
